const messages = {
  step3: {
    actionBtn: "Přihlásit se",
  },
};

export default {
  messages,
};
